import styled from 'styled-components'

import Background from '../Background'
import Button from '../Button/Button'
import IconButton from '../Button/IconButton'
import Row from '../Row'

import InputGroup from '../InputGroup'
import ButtonGroup from '../Button/ButtonGroup'

const Form = styled(Background)`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 64px;
  left: ${props => (props.show ? 0 : -100)}%;
  transition: left 0.5s ease-in-out;
  width: 100%;
  padding: ${props => props.theme.gutter}px;

  ${Row} {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  ${Row} + ${Row} {
    padding-top: ${props => props.theme.gutter}px;
  }

  ${IconButton} {
    height: 39px;
  }

  /* Mobile only */
  @media (max-width: 767.9px) {
    z-index: 1020;
    height: calc(100% - 64px);

    ${InputGroup}, ${InputGroup} ${Button} {
      width: 100%;
    }

    ${ButtonGroup} ${Button} {
      flex: 1;
    }

    ${InputGroup} + ${InputGroup} {
      padding-top: ${props => props.theme.gutter}px;
    }
  }

  @media (min-width: 768px) {
    top: 0;
    left: 0;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: ${props => props.theme.gutter}px 0;

    ${InputGroup} + ${InputGroup} {
      padding-left: ${props => props.theme.gutter}px;
    }
  }

  @media (min-width: 992px) {
    ${Row}:nth-child(1), ${Row}:nth-child(3) {
      flex: 0 0 30%;
      max-width: 30%;
    }

    ${Row}:nth-child(2) {
      flex: 0 0 40%;
      max-width: 40%;
    }

    ${Row} + ${Row} {
      padding-top: 0;
      padding-left: ${props => props.theme.gutter}px;
    }
  }
`

export default Form
